import { useCallback, useMemo } from "react";
import {
  CONVERSION_MODE,
  STORE_LINKS,
} from "../constants/config";
import { trackEvent } from "../services/analytics";

const CTA_LABELS = {
  candidat: {
    waitlist: "Rejoins la liste d'attente",
    stores: "Télécharger l'app",
  },
  entreprise: {
    waitlist: "Pré-inscription entreprise",
    stores: "Pré-inscription entreprise",
  },
};

function getStoreUrl() {
  const isIOS =
    typeof navigator !== "undefined" &&
    /iPad|iPhone|iPod/.test(navigator.userAgent);

  if (isIOS && STORE_LINKS.ios) return STORE_LINKS.ios;
  if (STORE_LINKS.android) return STORE_LINKS.android;
  return STORE_LINKS.ios || STORE_LINKS.android || null;
}

export function useConversion({ variant, openModal }) {
  const mode = CONVERSION_MODE;
  const isCandidat = variant === "candidat";

  const ctaLabel = useMemo(() => {
    const labels = CTA_LABELS[variant] || CTA_LABELS.candidat;
    return labels[mode] || labels.waitlist;
  }, [variant, mode]);

  const handlePrimaryAction = useCallback(
    (location = "unknown") => {
      trackEvent("cta_click", { location, variant });

      if (mode === "stores" && isCandidat) {
        const storeUrl = getStoreUrl();
        if (storeUrl) {
          window.open(storeUrl, "_blank", "noopener,noreferrer");
          return;
        }
        const badges = document.getElementById("store-badges");
        if (badges) {
          badges.scrollIntoView({ behavior: "smooth" });
        }
        return;
      }

      openModal?.();
    },
    [mode, isCandidat, variant, openModal]
  );

  return { ctaLabel, handlePrimaryAction, mode };
}
